import api from './api'

// Note: Tokens now in httpOnly cookies, not accessible to JavaScript
// Authentication state checked via API calls

export const isAuthenticated = () => {
  // Check if username exists (set on login)
  // Real auth validation happens on backend via httpOnly cookies
  return !!localStorage.getItem('username')
}

export const getUserFromToken = () => {
  // Username stored in localStorage for display purposes
  const username = localStorage.getItem('username')
  return username ? { sub: username } : null
}

// Clear authentication cookies by calling backend logout
export const clearAuthCookies = async () => {
  try {
    const hasUser = !!localStorage.getItem('username')
    const hasMail = !!localStorage.getItem('mail')
    if (!hasUser && !hasMail) {
      // No local session to clear; avoid calling logout on startup
      return
    }
    // Backend will clear httpOnly cookies (access_token and refresh_token)
    await api.post('/auth/logout')
    console.log('✅ Auth cookies cleared')
  } catch (error) {
    console.error('⚠️ Error clearing auth cookies:', error)
    // Even if backend call fails, continue with local cleanup
  }
}

export const logout = async () => {
  try {
    // Backend will clear httpOnly cookies
    await api.post('/auth/logout')
  } catch (error) {
    console.error('Logout error:', error)
  } finally {
    // Clear username and email from localStorage
    localStorage.removeItem('username')
    localStorage.removeItem('mail')
    window.location.href = '/login'
  }
}

